import { ProjectType, PROJECT_TYPE_TITLE } from "@/consts/Project";
import { ProjectType as BidProjectType } from "@/consts/Bid";

export const typeToTitle = (type: ProjectType) => PROJECT_TYPE_TITLE[type];

export const downloadFile = ({
  file_name,
  download_url,
}: {
  file_name: string;
  download_url: string;
}) => {
  const a = document.createElement("a");
  a.href = download_url;
  a.download = file_name;
  a.click();
};

export const parseProjectType = (type: BidProjectType) => {
  switch (type) {
    case BidProjectType.BidPlan:
      return ProjectType.PLAN;
    case BidProjectType.Procure:
      return ProjectType.PRCR;
    case BidProjectType.Original:
    default:
      return ProjectType.PROJ;
  }
};

export const parseProjectTypeToBid = (type: ProjectType) => {
  switch (type) {
    case ProjectType.PLAN:
      return BidProjectType.BidPlan;
    case ProjectType.PRCR:
      return BidProjectType.Procure;
    case ProjectType.PROJ:
    default:
      return BidProjectType.Original;
  }
};
